export interface BoipaConfig {
  /** To be used only by UpCo. Don't use it for Merchant's payment like giftcard, weborder, etc. */
  internalMIDs: {
    merchantId: string;
    password: string;
    brandId: string;
    currency: string;
    country: string;
  }[];
  tokenUrl: string;
  processingUrl: string;
  actionUrl: string;
  allowOriginUrl: string;
  pieCloud: {
    notificationUrl?: string;
    landingUrl?: string;
    successPageUrl?: string;
    failPageUrl?: string;
  };
  pieCloudV2: {
    notificationUrl?: string;
    landingUrl?: string;
  };
  evervault: {
    token: string;
    outboundRelayDebugRequests: boolean;
    team_token: string;
    app_token: string;
  };
  debugMessages: boolean;
}
export {};
